export const EMU_2018_CHANGE_LAYER_ID_3D = '48ceeedf110f45e5a2d9f643cc9fb5f6';
export const EMU_2018_CHANGE_LAYER_ID_2D = '0f88fbb467084516a7a0f0344dfe8738';

export const EMU_2018_CHANGE_LAYER_FIELDS_2D = {
    DEPTH_LEVEL: 'Depth_Level',
    DEPTH: 'Depth',
};
